import Vue from "vue";
import Vuex from "vuex";
import app from "./modules/app";
import user from "./modules/user";
import permission from "./modules/permission";
import uploads from "./modules/uploads";
import planet from "./modules/planet";
import getters from "./getters";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    app,
    user,
    permission,
    uploads,
    planet,
  },
  getters,
});

export default store;
